export default "__VITE_ASSET__BZBnTMT2__"